// Was the pick a steal or a reach? Derived entirely on the client from data the
// pool already carries.
//
// The consensus slot is a player's 1-based *index* in the pool array, not their
// effective_rank value. The pool arrives sorted by effective rank and the
// provider stores it verbatim, so the index is the draft slot the board expected
// them to go at. effective_rank itself is `override || search_rank`, which
// without an imported CSV is Sleeper's global relevance rank — not a slot, and
// not comparable to an overall pick number.

export type VerdictKind = 'steal' | 'reach'

export interface Verdict {
  kind: VerdictKind
  /** Shouted word: "Steal" or "Reach". */
  word: string
  /** The quiet half: "fell 14", "21 early". */
  detail: string
  /** overall - consensusSlot. Positive means they fell. */
  delta: number
}

/**
 * `null` — the common case — means render nothing.
 *
 * Returns null whenever the pick landed within one round of its slot, and also
 * whenever the inputs cannot support a claim: an unresolved player, a pool that
 * has not loaded, or a draft with no teams. A missing verdict is always correct;
 * a wrong one is not.
 */
export function pickVerdict(
  overall: number,
  consensusSlot: number | undefined,
  teamCount: number,
): Verdict | null {
  if (consensusSlot == null || teamCount < 1) return null

  const delta = overall - consensusSlot
  // One full round off book, so the bar scales with league size.
  if (delta >= teamCount) return { kind: 'steal', word: 'Steal', detail: `fell ${delta}`, delta }
  if (-delta >= teamCount) return { kind: 'reach', word: 'Reach', detail: `${-delta} early`, delta }
  return null
}
